"use client"

import Documents from "./Documents"

/* eslint-disable @typescript-eslint/no-explicit-any */
export default function MyDocuments() {
  return (<Documents key={'allDocuments'} userId={null} />)
}
